import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home, 
    meta: {
      auth: true, 
      head: true
    }
  },
  {
    path: '/landing',
    name: 'Landing',
    component: () => import(/* webpackChunkName: "about" */ '../views/Landing2.vue'), 
    meta: {
      auth: false, 
      head: false
    }
  },
  {
    path: '/cancel_notification',
    name: 'Cancel',
    component: () => import(/* webpackChunkName: "about" */ '../views/Cancel.vue'), 
    meta: {
      auth: false, 
      head: false
    }
  },
  {
    path: '/social_redirect/:id',
    name: 'Social_redirect',
    component: () => import(/* webpackChunkName: "about" */ '../views/social_redirect.vue'), 
    meta: {
      auth: false, 
      head: false
    }
  },
  {
    path: '/cert/:id',
    name: 'Cert',
    component: () => import(/* webpackChunkName: "about" */ '../views/public_cert.vue'), 
    meta: {
      auth: false, 
      head: false
    }
  },
  {
    path: '/reset_password',
    name: 'Recover',
    component: () => import(/* webpackChunkName: "about" */ '../views/recover.vue'), 
    meta: {
      auth: false, 
      head: false
    }
  },
  {
    path: '/makeUser',
    name: 'MakeUser',
    component: () => import('../views/makeUser.vue'), 
    meta: {
      auth: true, 
      head:false
    }
  },
  {
    path: '/courses',
    name: 'Courses',
    component: () => import('../views/courses.vue'), 
    meta: {
      auth: true, 
      head:true
    }
  }, 
  {
    path: '/certificate',
    name: 'certificate',
    component: () => import('../views/certificate.vue'), 
    meta: {
      auth: true, 
      head:true
    }
  }, 
  {
    path: '/editUser',
    name: 'EditUser',
    component: () => import('../views/editUser.vue'), 
    meta: {
      auth: true, 
      head: true
    }
  }, 
  { path: "*", component: Home, meta: {
    auth: true, 
    head: true
  } }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const auth = {
	loggedIn() {
		return store.getters.isLogged
	},
	logout() {
		store.commit('setLogout')
	}
}
router.beforeEach((to, from, next) => {
	let authrequired = false
	if(to && to.meta && to.meta.auth)
		authrequired = true


	if(authrequired) {
		if(auth.loggedIn()) {
			if(to.name === 'Landing') {
				window.location.href = '/'
				return false
			} else { 
				next()
			}
		} else {
			if(to.name !== 'Landing'){
				window.location.href = '/landing'
				return false
			}
			next()
		}
	} else {
		if(auth.loggedIn() && to.name === 'Landing'){
			window.location.href = '/'
			return false
		} else {
			next()
		}
	}
})


export default router
